export const TEXTS = {
  TITLE: 'Изменить комментарий к адресу',
  INPUT_PLACEHOLDER: 'Введите комментарий к адресу',
  SAVE_BUTTON_TEXT: 'Сохранить',
  NOTIFICATION_SUCCESS_TEXT: 'Комментарий к адресу изменен',
  NOTIFICATION_ERROR_TOO_LONG_TEXT: 'Максимальная длина комментария - 1024 символа',
};
